import React from "react";

import {

    Card,
    CardContent,
    CardActions,
    Typography,
    Chip,
    Stack,
    Button,
    Box

} from "@mui/material";

import DescriptionIcon from "@mui/icons-material/Description";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ArticleIcon from "@mui/icons-material/Article";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

export default function KnowledgeCard({ item }) {

    const getIcon = () => {

        switch (item.mimeType) {

            case "application/pdf":
                return <PictureAsPdfIcon color="error" />;

            case "application/vnd.google-apps.document":
                return <ArticleIcon color="primary" />;

            case "application/vnd.google-apps.presentation":
                return <SlideshowIcon color="warning" />;

            case "video/mp4":
                return <VideoLibraryIcon color="secondary" />;

            default:
                return <DescriptionIcon color="action" />;
        }

    };

    const openDocument = () => {

        if (item.webViewLink) {

            window.open(item.webViewLink, "_blank");

        }

    };

    return (

        <Card
            elevation={3}
            sx={{

                height: "100%",

                display: "flex",

                flexDirection: "column",

                borderRadius: 3,

                transition: "0.2s",

                "&:hover": {

                    transform: "translateY(-4px)",

                    boxShadow: 8

                }

            }}
        >

            <CardContent sx={{ flexGrow: 1 }}>

                <Box mb={2}>

                    {getIcon()}

                </Box>

                <Typography

                    variant="h6"

                    fontWeight="bold"

                    gutterBottom

                >

                    {item.title || item.name}

                </Typography>

                <Stack
                    direction="row"
                    spacing={1}
                    mb={2}
                    flexWrap="wrap"
                >

                    <Chip

                        label={item.category || "General"}

                        size="small"

                        color="primary"

                    />

                    <Chip

                        label={item.type || "Document"}

                        size="small"

                        variant="outlined"

                    />

                </Stack>

                <Typography

                    variant="body2"

                    color="text.secondary"

                >

                    Updated

                </Typography>

                <Typography variant="body2">

                    {

                        item.modifiedTime

                            ? new Date(item.modifiedTime).toLocaleDateString()

                            : "-"

                    }

                </Typography>

            </CardContent>

            <CardActions>

                <Button

                    fullWidth

                    variant="contained"

                    onClick={openDocument}

                >

                    Open

                </Button>

            </CardActions>

        </Card>

    );

}